<template lang="pug">
    .settings-head__menu
        .settings-head__menu-item(v-for="item in menu" :key="item.route" :class="{'active' : isCurrentRoute(item.route) }")
            router-link(:to="{name: item.route}")
                svg-icon(:iconId="item.icon" useClass="settings-head__menu-item-icon")
                span {{ item.title }}
</template>

<script>
import { mapGetters } from 'vuex'
import ScrollAccessMixin from '../../mixins/scroll-access-mixin'

export default {
    name: "settings-page-head",

    mixins: [
        ScrollAccessMixin,
    ],

    computed: {
        ...mapGetters(['authUser']),

        currentRoute() {
            return this.$route.name
        },

        hasBasicInfo() {
            return this.authUser.username && this.authUser.name
        },
        gmhReady() {
            return this.authUser.meta.gmh_ready
        },

        menu() {
            const menu = [
                {
                    icon: 'settings-profile',
                    route: 'settings-profile-page',
                    title: "My Profile"
                },
            ]

            if (this.gmhReady) {
                menu.push({
                    icon: 'settings-account',
                    route: 'settings-account-management',
                    title: "Account Management"
                })
            }

            if (this.$store.getters.authUser.creator) {
                menu.push({
                    icon: 'settings-store',
                    route: 'settings-store-page',
                    title: "Store"
                })
                menu.push({
                    icon: 'settings-media-vault',
                    route: 'settings-media-vault-page',
                    title: 'Media Vault',
                })
            }

            if (this.gmhReady) {
                menu.push({
                    icon: 'settings-earnings',
                    route: 'settings-earning-dashboard-page',
                    title: "Earning Dashboard"
                })
                menu.push({
                    icon: 'settings-store',
                    route: 'settings-purchased-page',
                    title: "Purchases"
                })
                menu.push({
                    icon: 'settings-become-creator',
                    route: 'settings-become-creator-page',
                    title: "Become a Creator"
                })
            }

            return menu
        },
    },

    methods: {
        isCurrentRoute(name) {
            return this.currentRoute === name
        },
    }
}
</script>
